exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "h4{color:#768291;font-size:20px;font-weight:600;margin-bottom:25px}.billEstimate{padding:80px 0}.billEstimate h6{font-size:18px;color:#8f97a3;margin-bottom:0}.billEstimate h2{color:#265390;font-size:46px;font-weight:600;margin-top:5px}.billEstimate h2 span{font-size:30px}.pdfDownloadCol{width:50px}.amountCol{width:100px}.btn-group-1{position:absolute;bottom:30px;right:15px}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/accounts/billing/billing.component.scss
// module id = 1350
// module chunks = 4